import styled from '@emotion/styled';
import Image from 'next/image';
import { ButtonBase, SxProps } from '@mui/material';
import { Theme } from '@mui/material/styles';

const StyledTitle = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre;
  display: flex;
  align-items: center;
  gap: 4px;
`;
const StyledListTitle = styled.div`
  overflow: hidden;
  white-space: wrap;
  text-overflow: ellipsis;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 2; // 원하는 라인수
  -webkit-box-orient: vertical;
`;

const StyledListSubTitle = styled.div`
  font-size: 12px;
  color: #888d96;
  line-height: 20px;
  font-weight: 400;
`;

const LayoutImage = styled(Image)<{ isSelected: boolean }>`
  border-radius: 50%;
  object-fit: cover;
  border: ${({ isSelected }) => (isSelected ? '1px solid #0066cc' : '')};
  padding: 4px;
  box-sizing: content-box;
`;

const DropdownContainer = styled.div`
  position: relative;
  width: fit-content;
`;

interface DropdownHeaderProps {
  isOpen: boolean;
  customStyle?: SxProps<Theme>;
}

const DropdownHeader = styled(ButtonBase, {
  shouldForwardProp: (prop) => prop !== 'isOpen' && prop !== 'customStyle',
})<DropdownHeaderProps>(({ isOpen, theme, customStyle }) => ({
  fontSize: 14,
  background: '#ffffff',
  border: '1px solid',
  borderColor: isOpen ? 'black' : '#e7e9ec',
  borderRadius: 6,
  padding: '10px 12px',
  height: '44px',
  cursor: 'pointer',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
  '&:disabled': {
    background: '#F9FAFB',
    borderColor: '#F9FAFB',
    cursor: 'not-allowed',
  },
  '&:hover': {
    borderColor: 'black',
  },
  ...((customStyle ?? {}) as any), // headerStyle 강제 병합
}));

const DropdownListContainer = styled.div<{ isFocus: boolean }>`
  position: absolute;
  z-index: 10;
  top: 100%;
  left: 0;
  width: 100%;
  visibility: ${({ isFocus }) => (isFocus ? 'visible' : 'hidden')};
  opacity: ${({ isFocus }) => (isFocus ? '1' : '0')};
  transition: all 0.2s ease-in;
`;

const DropdownList = styled.ul`
  width: 100%;
  padding: 8px;
  border: 1px solid black;
  border-radius: 6px;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  gap: 4px;
  list-style: none;
  margin-block-start: 8px;
  margin-block-end: 8px;
`;

const DropdownListItem = styled.li<{ isSelected: boolean }>`
  padding: 4px;
  cursor: pointer;
  background-color: ${({ isSelected }) => (isSelected ? '#F9FAFB' : '#ffffff')};
  color: black;
  font-weight: ${({ isSelected }) => (isSelected ? '500' : '400')};
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 6px;
  &:hover {
    background-color: #f9fafb;
  }
`;

export {
  LayoutImage,
  StyledTitle,
  StyledListTitle,
  DropdownContainer,
  DropdownHeader,
  DropdownListContainer,
  DropdownList,
  DropdownListItem,
  StyledListSubTitle,
};
